module.exports = __webpack_public_path__ + "static/media/Colombia.08a2f61e.png";